import {GabbyStory} from './gabby/GabbyStory'
import {KailisStory} from "./kailis/KailisStory";
import {ElfStory} from "./elf/ElfStory";
import { KailisStoryPart2 } from './kailis/KailisStoryPart2';
import {TowerStory} from "./tower/TowerStory";
import {TowerStoryPart2} from "./tower/TowerStoryPart2";
import {PromoStory} from "./PromoStory";
import {TrollStory} from "./troll/TrollStory";
import {VampiresStory} from "./vampires/VampiresStory";
import {SeaStory} from "./sea/SeaStory";
import {TutorialStory} from "./tutorial/TutorialStory";
import {SeaStoryPart2} from "./sea/SeaStoryPart2";
import {LustTower} from "./lustTower/LustTower";

export default {
    PromoStory,
    TutorialStory,
    LustTower,
    GabbyStory,
    KailisStory,
    KailisStoryPart2,
    TowerStory,
    TowerStoryPart2,
    ElfStory,
    TrollStory,
    VampiresStory,
    SeaStory,
    SeaStoryPart2,

}
